import { resolveUiHelper } from '../utils/resolve-ui-helper.js';

/**
 * What the teams controller says to the person: a toast, or an alert. Teams
 * are created and edited in Settings › Teams & structure; the modal this view
 * used to bind is gone.
 */
export class TeamsView {
  constructor({
    document = typeof window !== 'undefined' ? window.document : null,
    toast = null,
    notify = null,
  } = {}) {
    this.document = document;
    const helper = toast ? null : resolveUiHelper() || {};
    const resolvedToast =
      typeof toast === 'function'
        ? toast
        : typeof helper?.showToast === 'function'
        ? helper.showToast
        : typeof window !== 'undefined' && typeof window.toast === 'function'
        ? window.toast
        : () => {};
    this.toastFn = resolvedToast;
    this.notifyFn = typeof notify === 'function' ? notify : (message, type, title, duration) => this.toastFn(message, type, title, duration);
  }

  notify(message, type = 'info', title, duration) {
    this.notifyFn(message, type, title, duration);
  }

  alert(message) {
    if (typeof window !== 'undefined' && typeof window.alert === 'function') {
      window.alert(message);
      return;
    }
    this.toastFn(message, 'error');
  }
}

if (typeof window !== 'undefined') {
  window.AgileProViews = window.AgileProViews || {};
  window.AgileProViews.TeamsView = TeamsView;
}
